/**
 * The label to display when selected the filter
 */
export const labelCompetenzeColf = 'Competenze Colf';
